import React from 'react';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import LogoImg from 'assets/logo.svg';

export const Footer = () => {
  return (
    <footer className="w-full  text-gray-800 py-8 px-6 md:px-16">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center">
        {/* Social Media Links */}
        <div className="flex space-x-6 mb-6">
          <a
            href="https://x.com/wire24app"
            target="_blank"
            rel="noreferrer"
            className="text-gray-800 text-lg hover:text-gray-400"
          >
            <FaTwitter />
          </a>
          <a
            href="https://facebook.com/wire24app"
            target="_blank"
            rel="noreferrer"
            className="text-gray-800 text-lg hover:text-gray-400"
          >
            <FaFacebookF />
          </a>

          <a
            href="https://linkedin.com/in/wire24app"
            target="_blank"
            rel="noreferrer"
            className="text-gray-800 text-lg hover:text-gray-400"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://instagram.com/wire24app"
            target="_blank"
            rel="noreferrer"
            className="text-gray-800 text-lg hover:text-gray-400"
          >
            <FaInstagram />
          </a>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center space-x-4 md:space-x-8 mb-6">
          <Link to="/company" className="text-gray-500 hover:text-gray-500">
            About Us
          </Link>
          <Link to="/contact" className="text-gray-500 hover:text-gray-500">
            Contact
          </Link>
          <Link to="/customer-acceptance" className="text-gray-500 hover:text-gray-500">
            Customer Acceptance
          </Link>
        </div>

        {/* Footer Bottom */}
        <div className="w-full flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm">
          <div className="flex space-x-4">
            <img src={LogoImg} alt="logo" className="h-4" />
            <span className="">Wire24 &copy; {new Date().getFullYear()}. All rights reserved.</span>
          </div>
          <div className="flex space-x-4">
            <Link to="/terms-of-service" className="text-gray-500 hover:text-gray-500">
              Terms of Service
            </Link>
            <span>|</span>
            <Link to="/privacy-policy" className="text-gray-500 hover:text-gray-500">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
